<button (click)="pressed.emit()" class="home-page__adress" type="button">
  <ion-icon name="location"></ion-icon>
  <span>{{ adressMessage }}</span>
  <ion-icon name="chevron-forward-outline"></ion-icon>
</button>
